import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "mx-context-menu-item-wrapper" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "mx-right-arrow" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VNodeRender = _resolveComponent("VNodeRender")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.globalHasSlot('itemRender'))
      ? (_openBlock(), _createBlock(_component_VNodeRender, {
          key: 0,
          vnode: () => _ctx.globalRenderSlot('itemRender', _ctx.getItemDataForChildren())
        }, null, 8, ["vnode"]))
      : (_ctx.customRender)
        ? (_openBlock(), _createBlock(_component_VNodeRender, {
            key: 1,
            vnode: _ctx.customRender,
            data: _ctx.getItemDataForChildren()
          }, null, 8, ["vnode", "data"]))
        : (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass('mx-context-menu-item' + (_ctx.disabled ? ' disabled' : '') + (_ctx.customClass ? (' ' + _ctx.customClass) : '')),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args))),
            onMouseenter: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onMouseEnter && _ctx.onMouseEnter(...args)))
          }, [
            _renderSlot(_ctx.$slots, "default", {}, () => [
              _renderSlot(_ctx.$slots, "icon", {}, () => [
                (_ctx.globalHasSlot('itemIconRender'))
                  ? (_openBlock(), _createBlock(_component_VNodeRender, {
                      key: 0,
                      vnode: () => _ctx.globalRenderSlot('itemIconRender', _ctx.getItemDataForChildren())
                    }, null, 8, ["vnode"]))
                  : (typeof _ctx.icon === 'string')
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 1,
                        class: _normalizeClass(_ctx.icon + ' icon '+ _ctx.iconFontClass)
                      }, null, 2))
                    : (_openBlock(), _createBlock(_component_VNodeRender, {
                        key: 2,
                        vnode: _ctx.icon,
                        data: _ctx.icon
                      }, null, 8, ["vnode", "data"]))
              ]),
              _renderSlot(_ctx.$slots, "label", {}, () => [
                (_ctx.globalHasSlot('itemLabelRender'))
                  ? (_openBlock(), _createBlock(_component_VNodeRender, {
                      key: 0,
                      vnode: () => _ctx.globalRenderSlot('itemLabelRender', _ctx.getItemDataForChildren())
                    }, null, 8, ["vnode"]))
                  : (typeof _ctx.label === 'string')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.label), 1))
                    : (_openBlock(), _createBlock(_component_VNodeRender, {
                        key: 2,
                        vnode: _ctx.label,
                        data: _ctx.label
                      }, null, 8, ["vnode", "data"]))
              ]),
              (_ctx.showRightArrow)
                ? _renderSlot(_ctx.$slots, "rightArrow", { key: 0 }, () => [
                    (_ctx.globalHasSlot('itemRightArrowRender'))
                      ? (_openBlock(), _createBlock(_component_VNodeRender, {
                          key: 0,
                          vnode: () => _ctx.globalRenderSlot('itemRightArrowRender', _ctx.getItemDataForChildren())
                        }, null, 8, ["vnode"]))
                      : _createCommentVNode("", true),
                    _hoisted_3
                  ])
                : _createCommentVNode("", true)
            ])
          ], 34)),
    (_ctx.showSubMenu)
      ? _renderSlot(_ctx.$slots, "submenu", { key: 3 })
      : _createCommentVNode("", true)
  ]))
}